// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="june-17-2022">June 17, 2022</h2>
      <p>We recently deprecated the higher_level_reviews endpoint for the <a href="https://developer.va.gov/explore/appeals/docs/decision_reviews?version=1.0.0">Decision Reviews API V1</a>. This endpoint is now removed, and its documentation is no longer available.<br />
      Consumers who were using this endpoint may instead use the following 2 new endpoints in the <a href="https://developer.va.gov/explore/appeals/docs/decision_reviews?version=current">Decision Reviews API V2</a>:</p>
      <ul>
      <li>Higher_level_reviews</li>
      <li>Legacy_appeals</li>
      </ul>
      <hr />
      <h3 id="april-20-2022">April 20, 2022</h3>
      <p>We added functionality to our Higher-Level Review (HLR) POST endpoint to support submissions by non-Veteran claimants. This allows HLRs to be submitted by dependents of a Veteran.</p>
      <h2 id="to-learn-more-read-the-decision-reviews-api-documentation.">To learn more, read the <a href="https://developer.va.gov/explore/appeals/docs/decision_reviews?version=current">Decision Reviews API documentation</a>.</h2>
      <h3 id="april-18-2022">April 18, 2022</h3>
      <p>We added 5 new endpoints to the Decision Reviews API. These endpoints allow you to:</p>
      <p>Submit a Supplemental Claim (VA Form 20-0995). Structured data is submitted to the API which generates the most recent version of the PDF claim.<br />
      Upload supporting evidence documents in PDF form with the Supplemental Claim.</p>
      <hr />
      <h3 id="january-11th-2022">January 11th, 2022</h3>
      <p>Release Notes for new Contestable Issues standalone endpoint</p>
      <p>We added a new endpoint (<code>{'GET /contestable_issues/{decision_review_type}'}</code>) to the Decision Reviews API. This endpoint returns contestable issues for a specific Veteran. Using this endpoint lets you tailor your appeal submission flow based on the Veteran’s issues.</p>
      <p>This endpoint returns contestable issues for a single Veteran based on the Veteran’s social security number.<br />
      You can search for contestable issues based on these appeal types: higher_level_reviews, notice_of_disagreements, and supplemental_claims.<br />
      The endpoint returns only issues that have been decided as of the receiptDate.<br />
      Read the Decision Review API documentation to learn more.</p>
      <hr />
      <h3 id="july-26th-2021">July 26th, 2021</h3>
      <p>Decision Reviews API version 2 Release Notes</p>
      <p>Version 2 of the Decision Reviews API is now released with the following changes:</p>
      <p>We've added a new key, <code>informalConferenceContact</code> (required when an informal conference is requested), which will allow us to support both Veteran and representative contacts for informal conferences.<br />
      We've updated the possible responses enum of <code>informalConferenceTime</code> to reflect the above  changes.<br />
      <code>socOptIn</code> is now required.<br />
      For the representative name, we've split <code>name</code> into <code>firstName</code> and <code>lastName</code> to be more flexible and allow more accurate entries.<br />
      The Veteran email field <code>emailAddressText</code> has been changed to <code>email</code>.</p>
      <p>Added hlrCreateAddress to now accept an address for this API. This change follows NOD format:<br />
      -<code>addressLine1</code><br />
      -<code>addressLine2</code><br />
      -<code>addressLine3</code><br />
      -<code>city</code><br />
      -<code>stateCode</code> - enum of all 2-character state codes (see the documentation for more info)<br />
      -<code>countryCodeISO2</code><br />
      -<code>zipCode5</code></p>
      <hr />
      <h3 id="june-6-2020">June 6, 2020</h3>
      <p>Initial release of the Decision Review API</p>
    </div>
  );
};

export default MarkdownComponent;
